import Loadable from "../../react-loadable";
// import Table from './Table';
const Table = Loadable({
  loader: () => import("./Table"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default Table;



// WEBPACK FOOTER //
// ./_antd1.11.2/table/index.jsx